import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function EmailIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox='0 0 14 12'
    >
      <path
        d='M11.6667 0.666626H2.33337C1.80294 0.666626 1.29423 0.87734 0.919161 1.25241C0.544088 1.62749 0.333374 2.13619 0.333374 2.66663V9.33329C0.333374 9.86372 0.544088 10.3724 0.919161 10.7475C1.29423 11.1226 1.80294 11.3333 2.33337 11.3333H11.6667C12.1971 11.3333 12.7058 11.1226 13.0809 10.7475C13.456 10.3724 13.6667 9.86372 13.6667 9.33329V2.66663C13.6667 2.13619 13.456 1.62749 13.0809 1.25241C12.7058 0.87734 12.1971 0.666626 11.6667 0.666626ZM11.22 1.99996L7.00004 5.16663L2.78004 1.99996H11.22ZM11.6667 9.99996H2.33337C2.15656 9.99996 1.98699 9.92972 1.86197 9.8047C1.73695 9.67967 1.66671 9.5101 1.66671 9.33329V2.83329L6.60004 6.53329C6.71544 6.61984 6.85579 6.66663 7.00004 6.66663C7.14429 6.66663 7.28464 6.61984 7.40004 6.53329L12.3334 2.83329V9.33329C12.3334 9.5101 12.2631 9.67967 12.1381 9.8047C12.0131 9.92972 11.8435 9.99996 11.6667 9.99996Z'
        fill='#3B3C40'
      />
    </SvgIcon>
  );
}
